var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPod = function SvgPod(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#110737",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4.5,
    height: 10.5,
    x: 3.75,
    y: 12.75,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.5,
    height: 10.5,
    x: 15.75,
    y: 12.75,
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.75 18v-6C.75 5.787 5.787.75 12 .75S23.25 5.787 23.25 12v6"
  }))));
};
export default SvgPod;